<template>
    <v-row justify="center">
        <v-dialog v-model="show" max-width="400" v-if="item">
            <v-card>
                <v-card-title style="justify-content: center;">{{$t('subOrder.quantityConfirmation')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-text-field
                        :value="item.product_quantity"
                        :label="$t('subOrder.requestedQuantity')"
                        disabled>
                    </v-text-field>
                    <v-select 
                        v-model="confirmedQuantity"
                        :items=listOfQuantities
                        :label="$t('subOrder.confirmedQuantity')">
                    </v-select>
                </v-card-text>
                <v-card-actions class="pa-0">
                    <v-btn color="secondary" tile block @click="save()">{{$t('subOrder.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    name: "productValidationDialog",
    props: {
        item: Object,
        value: Boolean
    },
    data () {
        return {
            confirmedQuantity: this.item.product_quantity
        }
    },
    computed: {
        listOfQuantities: function() {
            let quantities = []
            for (let index = 0; index < this.item.product_quantity; index++) {
                quantities.push(index+1)
            }

            return quantities
        },
        show: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        save: function(){
            this.$emit("validateProductQuantity", this.confirmedQuantity)
        },
    }
}
</script>